import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { ServerEvent } from "@/Common/Stores/Actions/ServerEvent";
import { BaseStore } from "@/Common/Stores/BaseStore";
import { ServerResponseMapper } from "@/Common/Stores/Handlers/Server/RequestMapper";
import { RamqActions } from "./Actions/RamqAction";
import { RAMQResponseHandler } from "./Handlers/Server/RAMQResponseHandler";

let defaultInstance: RamqStore;

class RamqStore extends BaseStore {
    private ramqActions: RamqActions;
    private responseHandler: RAMQResponseHandler;
    private responseMapper: ServerResponseMapper;

    constructor() {
        super();
        var self = this;

        self.ramqActions = new RamqActions();
        this.responseMapper = new ServerResponseMapper();
        this.responseHandler = new RAMQResponseHandler(this.ramqActions);
        this.responseMapper.AddInstance(this.responseHandler);

        RAMQEventDispatcher.register((request: LocalEvent) => {
            if (request.Operation === LocalOperations.Misc.RAMQInfoInPatientReceived) {
                self.EmitChangeToListeners();
            }
        });

        this.ServerDispatchToken = ServerResponseDispatcher.register((response: ServerEvent) => self.responseMapper.Map(response, self));
    }

    public static createSingleton(): RamqStore {
        return this.createStoreSingleton(defaultInstance, () => defaultInstance = new RamqStore());
    }
}

export { RamqStore, defaultInstance as ramqStore };
